function Marquee(selector, speed) {
  // Respect user's motion preference
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const parent = document.querySelector(selector);
  if (!parent) return;

  const original = parent.innerHTML;
  parent.insertAdjacentHTML("beforeend", original);
  parent.insertAdjacentHTML("beforeend", original);

  const firstChild = parent.children[0];
  let offset = 0;
  let lastTime = null;

  function step(timestamp) {
    if (lastTime !== null) {
      const delta = timestamp - lastTime;
      offset += speed * delta;

      if (offset >= firstChild.clientWidth) {
        offset = 0;
      }

      firstChild.style.marginLeft = `-${offset}px`;
    }

    lastTime = timestamp;
    requestAnimationFrame(step);
  }

  requestAnimationFrame(step);
}

window.addEventListener("load", () => Marquee(".marquee", 0.08));
